import { PageTypeEnum } from '@moonpig/web-shared-products/src/types'
import {
  CreateViewGalleryResultsGAEventProps,
  createViewGalleryResultsGAEvent,
} from './createViewGalleryResultsGAEvent'
import { SearchGAEventProps, createSearchGAEvent } from './createSearchGAEvent'
import type {
  ViewGalleryResultsEvent,
  SearchEvent,
} from '@moonpig/web-core-analytics'

export const createViewResultsEvent = ({
  pageType,
  department,
  filters,
  sort,
  showNbas,
  showRudeProducts,
  numberOfResults,
  pageTitle,
  redirectedFrom,
  selectedSuggestion,
  isTrendingSuggestion,
  filteringEvent,
  searchTerm,
  correctedSearchTerm,
  redirectionSource,
}: SearchGAEventProps & CreateViewGalleryResultsGAEventProps):
  | ViewGalleryResultsEvent
  | SearchEvent => {
  return pageType === PageTypeEnum.COLLECTION
    ? createViewGalleryResultsGAEvent({
        department,
        filters,
        numberOfResults,
        pageTitle,
        sort,
        showNbas,
        showRudeProducts,
        pageType,
      })
    : createSearchGAEvent({
        correctedSearchTerm,
        department,
        filters,
        filteringEvent,
        numberOfResults,
        searchTerm,
        sort,
        selectedSuggestion,
        isTrendingSuggestion,
        showNbas,
        showRudeProducts,
        redirectedFrom,
        redirectionSource,
      })
}
